import './App.css';
import {BrowserRouter as Router, Routes , Route} from 'react-router-dom';
import Homepage from './pages/Homepage';
import AllColleges from './pages/AllColleges';
import Collegepage from './pages/Collegepage';
import ApplyPage from './pages/ApplyPage';
import SuccesPage from './pages/SuccessPage';
import Aboutpage from './pages/Aboutpage';
import SearchCollegePage from './pages/SearchedCollegePage';
import PrivacyPage from './pages/Privacypage';
import AdminPage from './pages/AdminPage';
import DashBoard from './pages/DashBoard';
import { useEffect, useState } from 'react';

function App() {

  const [CollegeData, setCollegeData] = useState([]);
    const [loading, setLoading] = useState(false);
  
    useEffect(() => {
      const fetchCollegeData = async () => {
        setLoading(true);
        try {
          const response = await fetch(`https://collegematebackend.onrender.com/api/colleges`);
          const data = await response.json();
          setCollegeData(data.colleges);
          console.log("fetched",data);
          setLoading(false);
        } catch (error) {
          console.error("Error fetching data: ", error);
        }
      }
      fetchCollegeData();
    }, []);

  return (
    <div className="App me-0">
      <Router>
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/colleges" element={<AllColleges CollegeData={CollegeData} />} />
          <Route path="/colleges/:collegeId" element={<Collegepage />} />
          <Route path="/apply" element={<ApplyPage />} />
          <Route path="/success" element={<SuccesPage />} />
          <Route path="/about" element={<Aboutpage />} />
          <Route path="/colleges/search/:searchQuery" element={<SearchCollegePage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path='/admin' element={<AdminPage />} />
          <Route path='/dashboard' element={<DashBoard />} />
          <Route path="*" element={<Homepage />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
